import {
  ICalibration,
  SuggestedCalibration,
} from 'spw-redux/modules/floorplan/types';
import { isNil, omit, pick } from 'ramda';
import { SUGGESTED_CALIBRATION_LINE_STATUS } from 'spw-esa-projects/building-details/floorplan/poll-suggested-calibration-line-hook';
import { isEqual } from 'lodash';

export const isCalibrationLineValid = (calibration: ICalibration) => {
  const properties = ['x1', 'x2', 'y1', 'y2'] as (keyof ICalibration)[];
  return properties.every((property) => !isNil(calibration?.[property]));
};

export const isSuggestedCalibrationValid = (
  suggestedCalibration: SuggestedCalibration
) => {
  return (
    suggestedCalibration?.status === SUGGESTED_CALIBRATION_LINE_STATUS.DONE &&
    isCalibrationLineValid(omit(['status'], suggestedCalibration))
  );
};

export const areCalibrationLinesEqual = (
  calibrationA: ICalibration | SuggestedCalibration,
  calibrationB: ICalibration | SuggestedCalibration
) => {
  const calibrationFields = ['x1', 'y1', 'x2', 'y2', 'constant'];
  return isEqual(
    pick(calibrationFields, calibrationA),
    pick(calibrationFields, calibrationB)
  );
};
